module.exports = __webpack_public_path__ + "media/images/bell-40e28d6ad9fc4026ae91de7a889a9c45.svg";